import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.comms_settings.location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { location_id },
    pause: !location_id,
    requestPolicy: 'cache-and-network',
  }
}
